<template>
  <div class="manage-container">
    <div class="tile is-parent">
      <article class="tile is-child box">
        <div class="control is-horizontal">
          <input type="text" class="input-text" v-model="params.accountName" placeholder="搜索公众号">
          <button class="button is-primary" @click="searchClick">搜索</button>
          <button class="button is-success" @click="removeCategoryClick" style="margin-left: 20px;">删除分类</button>
        </div>
          <div class="category-container clearfix" :class="{'category-edit-wrap':categoryEdit}">
          <span v-for="(item,key) in categoryList">
            <button class="is-outlined button" :class="{'is-info':item.isSelected,'is-edit':categoryEdit}"  @click="selectCategoryClick(item.categoryId,key)">{{item.categoryName}} • {{item.count}}</button>
          </span>
        </div>
      </article>
    </div>
    <div class="account-container">
      <div v-if="count > 0" class="clearfix">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="params.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box clearfix">
          <div class="account-item fleft" v-for="(item,key) in list">
              <router-link target='_blank' :to="{ name: 'subscriptionsDetail', query: {accountNumber: item.accountNumber, categoryId: '[]'} }">
                <img class="avatar fleft" :src="item.avatar">
                <div class="info fleft">
                  <p class="name">{{item.accountName}}</p>
                  <p class="account-number">微信号:{{item.accountNumber}}</p>
                  <p class="time">最近更新 {{item.lastDateTime}}</p>
                </div>
              </router-link>
            <button class="subscribe-btn button is-danger" @click="cancelSubscribeClick(key)">取消订阅</button>
          </div>
        </article>
      </div>
      <div v-if="count > 0" class="clearfix">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="params.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
  import {formatImageByQiniu} from 'UTILS/_url'
  import {formatDate} from 'UTILS/date'

  export default {
    data(){
      return {
        list:[],
        categoryList:[],
        currentPage:1,
        count:0,
        categoryEdit:false,
        params:{
          categoryIds:[],
          accountName:"",
          pageSize:20,
          page:1
        }
      }
    },
    created(){
      this.getCategoryList();
    },
    methods: {
      handleCurrentChange(value){
        if(this.params.page !== value){
          this.params.page = value;
          this.currentPage = value;
          this.getAccountList();
        }
      },
      getCategoryList(){
        HttpRequest.get("/admin.php?method=wechat.getAccountCategory", true).then((response) => {
          _.each(response.data,(item,index)=>{
            item.isSelected = false
          });
          this.categoryList = _.toArray(response.data);
          this.getAccountList();
        }, (response) => {});
      },
      getAccountList(){
        HttpRequest.get("/admin.php?method=wechat.getAccountList", this.params,true).then((response) => {
          this.list = _.toArray(response.data.list);
          _.each(this.list,(item,index)=>{
            item.avatar = formatImageByQiniu(item.avatar,100)
            item.lastDateTime = formatDate(item.lastDateTime,'yyyy-MM-dd hh:mm:ss');
          })
          this.count = response.data.count;
        }, (response) => {});
      },
      //取消订阅
      cancelSubscribeClick(index){
        let that = this;
        if(!confirm('确定要取消订阅吗？')){
          return false;
        }
        let params = {
          type:0,
          accountLink:this.list[index].accountLink,
          avatar:this.list[index].avatar,
          description:this.list[index].description,
          accountNumber:this.list[index].accountNumber,
          accountName:this.list[index].accountName,
          categoryIds:[0]
        };
        HttpRequest.post("/admin.php?method=wechat.subscribe", params,true).then((response) => {
          if(response.data.success){
            that.list.splice(index,1);
          }
        }, (response) => {});
      },
      //分类选中
      selectCategoryClick(id,index){
        //正在编辑分类,不进行筛选
        if(this.categoryEdit){
          this.removeCategory(id,index)
        }else{
          this.categorySearchClick(id,index);
        }
      },
      //移除分类
      removeCategory(id,index){
        let params = {
          categoryId:this.categoryList[index].categoryId
        }
        HttpRequest.post("/admin.php?method=wechat.removeCategory", params,true).then((response) => {
          if(response.data.success){
            this.categoryList.splice(index,1)
          }
        }, (response) => {});
      },
      //分类筛选
      categorySearchClick(id,index){
        this.params.categoryIds = [];
        _.each(this.categoryList,(item,k)=>{
          if(index == k){
            if(!item.isSelected){
              item.isSelected = true;
              this.params.categoryIds.push(this.categoryList[index].categoryId);
            }else{
              item.isSelected = false;
              this.params.categoryIds = []
            }
          }else{
            item.isSelected = false
          }
        })
        this.searchClick();
      },
      //搜索
      searchClick(){
        this.getAccountList();
      },
      //删除分类
      removeCategoryClick(){
        this.categoryEdit ? this.categoryEdit = false :  this.categoryEdit = true
      }
    }
  }
</script>
<style lang="less">
  .manage-container{
    .input-text{
      margin-right: 10px;
      width: 220px;
    }
    .category-container{
      margin: 20px 0 0 0;
      .button{
        margin: 0 10px 10px 0;
      }
      .is-edit{
        border: 2px dashed #ed6c63;
        position: relative;
      }
      .is-edit:after{
        content: "+";
        font-size: 20px;
        color: #ed6c63;
        display: inline-block;
        transform:rotate(45deg);
        -webkit-transform:rotate(45deg);
        position: absolute;
        right: -1px;
        top: -8px;
      }
    }
    .category-edit-wrap{
      border: 2px dashed #97cd76;
      padding: 20px;
    }
    .account-container{
      .account-item{
        margin: 0 20px 60px 0;
        width: 280px;
        .avatar-wrap{
          margin-bottom: 20px;
          display: block;
        }
        .avatar{
          width: 60px;
          height: 60px;
          display: inline-block;
          overflow: hidden;
          border-radius: 30px;
        }
        .info{
          margin-left:10px;
          .name{
            font-size: 20px;
            color: #333;
            font-weight: 500;
            width: 180px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            display: inline-block;
          }
          .account-number{
            font-size: 14px;
            color: #42afe3;
          }
          .time{
            font-size: 14px;
            color: #666;
          }
        }
      }
    }
  }
</style>
